import { createSlice } from '@reduxjs/toolkit';
import { createSelector } from 'reselect';
import { apiCallBegan } from './api';

import config from '../config/config';
// import { login } from 'common/authService';
const queryString = require('query-string');

// const apiMealEndpoint = '/api/meal/';
const apiToken = process.env.REACT_APP_API_TOKEN;
// const eventId = config.eventId
// const  {data}  = await http.get(`${apiEventEndpoint}${eventId}/eating?secret_key=${apiToken}`);

const slice = createSlice({
  name: 'user',
  initialState: {
    role: 'staff'
  },
  reducers: {
    roleSet: (user, action) => {
      user.role = action.payload;
    }
  }
});

const { roleSet } = slice.actions;
export default slice.reducer;

// Action Creators
// const eventId = config.eventId
// const  {data}  = await http.get(`${apiEventEndpoint}${eventId}/eating?secret_key=${apiToken}`);

export const autoLogin = location => {
  return async dispatch => {
    const search = location.state
      ? location.state.from.search
      : location.search;

    let role = 'staff';
    const { token } = queryString.parse(search);

    if (token) {
      if (checkToken(token)) {
        // Valid token
        role = getRoleByToken(token);
        saveToken(token);

        // Save token in storage
      }
    } else {
      const savedToken = getSavedToken();
      if (savedToken) role = getRoleByToken(savedToken);
    }

    // Set role in storage
    await dispatch({ type: roleSet.type, payload: role });
  };
};

const checkToken = token => {
  if (Object.keys(config.tokens).indexOf(token.toString()) > -1) return true;
  return false;
};

const getRoleByToken = token => {
  return config.tokens[token];
};

const getSavedToken = () => {
  const token = localStorage.getItem('token');
  if (token) return token;
  return false;
};

const saveToken = token => {
  localStorage.setItem('token', token);
};

export const roleSelector = createSelector(
  state => state.login,
  user => {
    if (user?.role) {
      return user.role;
    } else {
      // auth.logout();
      return 'staff';
    }
  }
);
